import { useState, useEffect } from "react";
import FetchMasterUserData from "../components/Pages/AccountPage/Utils/FetchMasterUserData";

export const useUserData = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // ✅ Step 1: Check if user is logged in
        const loggedIn = JSON.parse(localStorage.getItem("userLoggedin"));
        
        if (!loggedIn || !loggedIn.userId) {
          throw new Error("No logged-in user found. Please log in.");
        }

        console.log("✅ Logged-in user found:", loggedIn.userId);

        // ✅ Step 2: Fetch user data using FetchMasterUserData
        const data = await FetchMasterUserData(loggedIn.userId);
        
        if (!data) {
          throw new Error("Failed to fetch user data from server");
        }

        // ✅ Step 3: Validate data structure
        if (typeof data !== 'object') {
          throw new Error("Invalid user data format received");
        }

        console.log("✅ User data fetched successfully:", data);

        // ✅ Step 4: Update state with fetched data
        setUserData(data);
      } catch (err) {
        console.error("❌ Error fetching user data:", err);
        setError(err.message);
        
        // ✅ Set default fallback data on error
        setUserData({
          userId: "",
          name: { firstName: "", lastName: "" },
          isDeluzonSet: false,
          isOotshavSet: false,
          isKlamitySet: false,
          isProfileSet: false,
          nProfiles: 0,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  return { userData, loading, error };
};